import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export type CreateExpenseCategoryFormValues = {
  name: string;
  expense_type_id: string;
};

export type UpdateExpenseCategoryFormValues = {
  id: string;
} & CreateExpenseCategoryFormValues;

export const getExpenseCategories = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }

  const { data } = await axiosInstance.get("/expenses/categories", config);
  return data;
};

export const createExpenseCategory = async (
  data: CreateExpenseCategoryFormValues
) => {
  const response = await axiosInstance.post("/expenses/categories", data);
  return response.data;
};

export const updateExpenseCategory = async (
  id: string,
  data: UpdateExpenseCategoryFormValues
) => {
  const response = await axiosInstance.put(`/expenses/categories/${id}`, data);
  return response.data;
};

export const deleteExpenseCategory = async (id: string) => {
  const response = await axiosInstance.delete(`/expenses/categories/${id}`);
  return response.data;
};

export const restoreExpenseCategory = async (id: string) => {
  const response = await axiosInstance.post(
    `/expenses/categories/${id}/reactivate`
  );
  return response.data;
};
